import axios from '../../../../utills/axiosConfig';

export const fetchRoutes = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/route-masters', { params });
  return res.data;
};

export const addRoute = async (route) => {
  const res = await axios.post('/route-masters', route);
  return res.data;
};

export const updateRoute = async (id, route) => {
  const res = await axios.put(`/route-masters/${id}`, route);
  return res.data;
};

export const deleteRoute = async (id) => {
  const res = await axios.delete(`/route-masters/${id}`);
  return res.data;
};

export const importRouteCSV = async (formData) => {
  const { data } = await axios.post('/route-masters/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};